import {useEffect} from 'react';

/**
 * Patches document.title and the favicon <link> at runtime from a resolved
 * white-label config. public/index.html stays fully static (no
 * react-helmet) - each field is only touched if the config actually
 * supplies it, so a partial/missing config leaves the existing static
 * title/favicon untouched.
 *
 * @param {object|null} config - resolved white-label config
 */
export const useWhiteLabelDocumentMeta = (config) => {
  useEffect(() => {
    if (!config) return;

    if (config.meta?.pageTitle) {
      document.title = config.meta.pageTitle;
    }

    if (config.assets?.faviconUrl) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = config.assets.faviconUrl;
    }
  }, [config]);
};
